var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row page-title"},[_c('div',{staticClass:"col-md-12"},[_c('b-breadcrumb',{staticClass:"float-right mt-1",attrs:{"items":_vm.items}}),_c('h4',{staticClass:"mb-1 mt-0"},[_vm._v(_vm._s(_vm.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }